import { IAuthLoginTranslations, IAuthRegisterTranslations } from '.';

const login: IAuthLoginTranslations = {
  welcome: 'Bienvenido',
  email: 'Email',
  email_placeholder: 'Introduce tu email',
  password: 'Password',
  password_placeholder: 'Introduce tu password',
  login: 'Login',
  log_back: 'Estás de vuelta?',
  logged_out: 'Has sido logged out',
  or: 'o',
  other_account: 'Otra cuenta',
  forgot_password: '¿Olvidaste tu password?',
  newAccount: 'Nueva cuenta',
  wrong_password: 'No pudimos iniciar sesión con las credenciales especificadas',
};

const register: IAuthRegisterTranslations = {
  newAccount: 'Nueva cuenta',
  error: 'Hubo un error creando tu usuario. Por favor, inténtalo de nuevo más tarde.',
  cancel: 'Cancelar',
  signUp: 'Regístrate',
  welcome: 'Bienvenido a Beamian!',
  confirmationEmail: 'Hemos enviado un email confirmando tu cuenta. Por favor, mira tu inbox.',
  login: 'Login',
  password_not_match: 'Las passwords no coinciden.',
};

export default { login, register };
